<template>
    <div class="flex justify-between items-center gap-4">
        <div>
            <button
                type="button"
                class="btn-base btn-hollow"
                @click="back()"
                v-if="redemptionStep > 1"
            >
                Back
            </button>
        </div>
        <div class="flex gap-4">
            <button
                type="button"
                class="btn-base btn-hollow"
                @click="tripsStore.closeModal()"
            >
                Cancel
            </button>
            <button
                type="button"
                class="btn-base btn-dark"
                @click="handleRedemptionAction()"
            >
                {{ btnAction }}
            </button>
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';

const tripsStore = useTripsStore();
const { steps, redemptionStep, tripFormErrors, errors } =
    storeToRefs(tripsStore);

const btnAction = computed(() => {
    if (redemptionStep.value < steps.value.length) {
        return 'Next';
    }
    return 'Add';
});

const handleRedemptionAction = async () => {
    tripsStore.validateRedemption();

    if (!errors.value.length && !tripFormErrors.value.length > 0) {
        if (redemptionStep.value === steps.value.length) {
            await tripsStore.createRedemption();
        } else {
            redemptionStep.value = redemptionStep.value + 1;
        }
    }
};

const back = () => {
    if (redemptionStep.value === 1) {
        return;
    }
    redemptionStep.value = redemptionStep.value - 1;
};
</script>
